import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import VectorSource from "ol/source/Vector";
import { Feature } from "ol";
import GeoJSON from "ol/format/GeoJSON";
import { XYZ } from "ol/source";
import RefreshIcon from "@mui/icons-material/Refresh";
import Divider from "@mui/material/Divider";

import { Backdrop, IconButton } from "@mui/material";
import MKBox from "../../components/MKBox";
import MainLayout from "../MainLayout";
import MKTypography from "../../components/MKTypography";
import Tiles from "../../assets/geojson/tiles.json";
import CircularProgressWithLabel from "../../views/Progress/CircularProgressWithLabel";
import MKButton from "../../components/MKButton";
import formatDatetime from "../../utils/formatDatetime";
import models from "../../store/constant/models";
import formatTime from "../../utils/formatTime";
import GridCard from "../../views/Cards/GridCard";
import GridCardLayersComputing from "../../views/GridCard/GridCardLayersComputing";
import GridCardMapComputingView from "../../views/GridCard/GridCardMapComputingView";
import { bboxToGeom } from "../../utils/mapProcess";
import HTTP_API from "../../store/constant/httpApi";

const ComputingJobView = () => {
  const { jobID } = useParams();
  const navigate = useNavigate();

  const [progress, setProgress] = useState(0);

  const mapRef = useRef();
  const [map, setMap] = useState(null);

  const parentRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState(null);

  const [grids, setGrids] = useState([]);
  const [tiles, setTiles] = useState([]);
  const [geom, setGeom] = useState("");
  const [scenes, setScenes] = useState({ doneScenes: 0, allScenes: 0 });

  const [BreadcrumbsRoutes] = useState([
    { label: "Home", route: "/home" },
    { label: "Computing", route: "/computing" },
    { label: "View" },
  ]);

  const [jobInfo, setJobInfo] = useState(null);
  const [tasks, setTasks] = useState(null);
  const [jobStatus, setjobStatus] = useState("Pending");

  const tileFeatures = Tiles.features;
  const geoJSONFormat = new GeoJSON();
  const [gridSource] = useState(new VectorSource());
  const [specialSource] = useState(new VectorSource());
  const [tileSource] = useState(new VectorSource());
  const [xyzSource] = useState(new XYZ());

  const parseGridLabel = (g) => {
    if (g.status === "Done") {
      return {
        status: "Click Download",
        subStatus: "",
      };
    }
    if (
      g.status === "Failure" ||
      (g.status === "Pending" &&
        g.doneCount > 0 &&
        g.failureCount > 0 &&
        g.failureCount + g.doneCount === g.totalCount)
    ) {
      return {
        status: "Failure",
        subStatus: "",
      };
    }
    if (g.status === "Pending") {
      if (g.runningCount > 0) {
        return {
          status: `${((g.doneCount / Math.sqrt(g.totalCount + g.totalCount ** 2)) * 100).toFixed(
            0
          )}% Completed`,
          subStatus: `Remaining: ${g.totalCount - g.doneCount} tiles\nRunning: ${
            g.runningCount
          } tiles`,
        };
      }
      if (
        g.doneCount < g.totalCount &&
        g.doneCount + g.assignedCount + g.pendingCount === g.totalCount
      ) {
        return {
          status: `${((g.doneCount / Math.sqrt(g.totalCount + g.totalCount ** 2)) * 100).toFixed(
            0
          )}% Completed`,
          subStatus: `Remaining: ${g.totalCount - g.doneCount} tiles\nPending`,
        };
      }

      return {
        status: `${((g.doneCount / Math.sqrt(g.totalCount + g.totalCount ** 2)) * 100).toFixed(
          0
        )}% Completed`,
        subStatus: "",
      };
    }

    return {
      status: `${((g.doneCount / Math.sqrt(g.totalCount + g.totalCount ** 2)) * 100).toFixed(
        0
      )}% Completed`,
      subStatus: "",
    };
  };

  const parseStatus = (collection) => {
    const gridList = [];
    const tileList = [];
    let AllDoneScenes = 0;
    let AllScenesNum = 0;

    Object.entries(collection).map((grid) => {
      Object.entries(grid[1].collection).map((tile) => {
        if ("collection" in tile[1]) {
          const runningScenes = Object.values(tile[1].collection).filter(
            (scene) => scene.status === "Running"
          ).length;
          const doneScenes = Object.values(tile[1].collection).filter(
            (scene) => scene.status === "Done"
          ).length;
          const pendingScenes = Object.values(tile[1].collection).filter(
            (scene) => scene.status === "Pending"
          ).length;
          const failureScenes = Object.values(tile[1].collection).filter(
            (scene) => scene.status === "Failure"
          ).length;
          const assignedScenes = Object.values(tile[1].collection).filter(
            (scene) => scene.status === "Assigned"
          ).length;
          const scenesNum = Object.values(tile[1].collection).length;
          AllDoneScenes += doneScenes;
          AllScenesNum += scenesNum;

          let status = "Running";
          if (tile[1].status === "Done") {
            status = "Done";
          }
          if (tile[1].status === "Assigned" || tile[1].status === "Running") {
            status = "Running";
          }
          if (tile[1].status === "Pending") {
            if (
              doneScenes > 0 &&
              doneScenes < scenesNum &&
              doneScenes + pendingScenes + assignedScenes === scenesNum
            ) {
              status = "Running";
            }
            if (pendingScenes + assignedScenes === scenesNum) {
              status = "Pending";
            }
            if (
              doneScenes > 0 &&
              doneScenes < scenesNum &&
              doneScenes + failureScenes === scenesNum
            ) {
              status = "Failure";
            }
            if (runningScenes > 0) {
              status = "Running";
            }
          }

          tileList.push({
            name: tile[0],
            status,
            gridStatus: grid[1].status,
          });
        }
        return null;
      });
      return null;
    });

    Object.entries(collection).map((grid) => {
      const tilesStatus = [];
      Object.entries(grid[1].collection).map((tile) =>
        tileList.filter((a) => a.name === tile[0]).length !== 0
          ? tilesStatus.push({
              name: tile[0],
              status: tileList.filter((a) => a.name === tile[0])[0].status,
            })
          : null
      );
      const runningCount = tilesStatus.filter((item) => item.status === "Running").length;
      const pendingCount = tilesStatus.filter((item) => item.status === "Pending").length;
      const assignedCount = tilesStatus.filter((item) => item.status === "Assigned").length;
      const failureCount = tilesStatus.filter((item) => item.status === "Failure").length;
      const doneCount = tilesStatus.filter((item) => item.status === "Done").length;
      const totalCount = tilesStatus.length;

      gridList.push({
        id: grid[0],
        status: grid[1].status,
        pendingCount,
        assignedCount,
        failureCount,
        runningCount,
        doneCount,
        totalCount,
        uri: grid[1].uri,
        geom: bboxToGeom(grid[1].bbox),
      });
      return null;
    });

    setScenes({ allScenes: AllScenesNum, doneScenes: AllDoneScenes });

    setProgress(() => {
      let calResult = 0;
      calResult = gridList.every((g) => g.status === "Done")
        ? 1.0 // 当每个grid的状态为Done时，则总进度为1；否则根据grid内的tiles的状态计算进度（doneCount/根号(totalCount+totalCount平方)。最终每个grid的进度乘grid内的tiles数后求和,除以总tiles数量.
        : (() => {
            let calPartion = 0;
            const allNumTile = gridList
              .map((g) => g.totalCount)
              .reduce((accumulator, currentValue) => accumulator + currentValue, 0);
            gridList.map((g) => {
              calPartion +=
                ((g.doneCount / Math.sqrt(g.totalCount + g.totalCount ** 2)) * g.totalCount) /
                allNumTile;
              return null;
            });
            return calPartion;
          })();

      return parseInt(calResult.toFixed(2) * 100, 10);
    });

    if (grids !== gridList) {
      setGrids(gridList);
      const gridFeatureArray = [];
      gridList.map((g) => {
        const GridLabel = parseGridLabel(g);
        gridFeatureArray.push(
          new Feature({
            geometry: g.geom.transform("EPSG:4326", "EPSG:3857"),
            id: g.id,
            status: GridLabel.status,
            subStatus: GridLabel.subStatus,
            label: GridLabel.label,
            uri: g.uri,
          })
        );
        return null;
      });
      gridSource.clear();
      gridSource.addFeatures(gridFeatureArray);

      if (gridList.some((a) => a.uri !== null)) {
        console.log(gridList);
        axios
          .post("https://ejxj9rh4h0.execute-api.us-west-2.amazonaws.com/default", {
            job_id: jobID,
            files: gridList.map((a) => a.uri),
            colormap: '{"0":[0,0,0,255],"1":[0,0,255,255]}',
            scale: "@2x",
          })
          .then((r) => {
            if (r.data) {
              xyzSource.setUrl(r.data.xyz_url);
            }
          });
      }
    }

    if (tiles !== tileList) {
      setTiles(tileList);
      const tileFeatureArray = [];
      tileList.map((t) =>
        tileFeatures.find((a) => a.properties.Name === t.name)
          ? tileFeatureArray.push(
              new Feature({
                geometry: geoJSONFormat.readGeometry(
                  tileFeatures.filter((a) => a.properties.Name === t.name)[0].geometry
                ),
                id: t.name,
                status: t.status,
                gridStatus: t.gridStatus,
              })
            )
          : null
      );
      tileSource.clear();
      tileSource.addFeatures(tileFeatureArray);
    }
  };

  const [eplasedTime, setEplasedTime] = useState("");
  const startTimer = () => {
    const currentTime = Math.floor(Date.now() / 1000);
    const timeDifference = currentTime - jobInfo.submission_time;

    setEplasedTime(formatTime(timeDifference));
  };
  if (jobInfo && jobInfo.status !== "Done") {
    setInterval(startTimer, 1000);
  }

  const fetchJob = () => {
    try {
      // console.log("fetchJob");
      axios
        .post("https://up9tz2e57j.execute-api.us-west-2.amazonaws.com/default/lucc_api", {
          operation: "get_job",
          payload: { job_id: jobID },
        })
        .then((r) => {
          setJobInfo(r.data);
          // console.log(r.data);
          if (r.data.geom !== geom) {
            setGeom(r.data.geom);
            const geoStr1 = r.data.geom.replace(/['"]/g, (match) => (match === '"' ? "'" : '"'));
            const geomStr2 = geoStr1.replace(/(None)/g, () => "{}");
            const specialFeatures = geoJSONFormat.readFeatures(geomStr2);
            const specialTransFeatures = specialFeatures.map(
              (f) =>
                new Feature({
                  geometry: f.getGeometry().transform("EPSG:4326", "EPSG:3857"),
                })
            );
            specialSource.clear();
            specialSource.addFeatures(specialTransFeatures);
          }
        });
    } catch (error) {
      console.error(error);
    }
  };

  const [submitBackdrop, setSubmitBackdrop] = useState(false);
  const handleBackdropClose = () => {
    setSubmitBackdrop(false);
  };
  const [assignedTask, setAssignedTask] = useState(null);
  const intervalIdRef = useRef(null);
  const [allTaskStatus, setAllTaskStatus] = useState([]);

  const fetchTasks = () => {
    try {
      console.log("fetchTasks");
      axios
        .post("https://up9tz2e57j.execute-api.us-west-2.amazonaws.com/default/lucc_api", {
          operation: "list_tasks",
          payload: { job_id: jobID },
        })
        .then((r) => {
          console.log(r.data);

          const mergedCollection = {};
          r.data.forEach((obj) => {
            const { collection } = obj;
            Object.keys(collection).forEach((key) => {
              if (!mergedCollection[key]) {
                mergedCollection[key] = collection[key];
              } else {
                mergedCollection[key].collection = {
                  ...mergedCollection[key].collection,
                  ...collection[key].collection,
                };
              }
            });
          });
          setTasks(mergedCollection);
          parseStatus(mergedCollection);

          const newTaskStatus = r.data.map((t) => ({
            id: t.task_id,
            emptytiles: t.empty_tiles,
            start: false,
            status: t.status,
          }));

          setAllTaskStatus([...allTaskStatus, ...newTaskStatus]);

          const checkTaskStatus = (ts) => {
            // 如果所有任务状态都是"Pending"，将整个任务状态设置为"Pending"
            if (ts.every((task) => task.status === "Pending")) {
              setjobStatus("Pending");
              clearInterval(intervalIdRef.current);
              intervalIdRef.current = setInterval(fetchTasks, 10000);
            }
            // 如果有任何一个任务状态是"Assigned"
            else if (ts.some((task) => task.status === "Assigned")) {
              const assignedT = ts.find((t) => t.status === "Assigned");
              // console.log('如果有任何一个任务状态是"Assigned"');
              // console.log(assignedT);
              if (assignedTask) {
                // 如果手动启动过任务,发送请求自动启动任务
                // console.log("如果手动启动过任务,发送请求自动启动任务");
                axios.post(HTTP_API.LUCC, {
                  operation: "start_task",
                  payload: {
                    job: jobID,
                    task: assignedT.id,
                  },
                });
              } else {
                // 如果任务尚未启动，则手动启动任务
                // console.log("Assigned ,to be started");
                // console.log(assignedT);
                setAssignedTask(assignedT);
                setSubmitBackdrop(true);
              }
              clearInterval(intervalIdRef.current);
              intervalIdRef.current = setInterval(fetchTasks, 8000);
            } else if (ts.every((t) => t.status === "Done") && intervalIdRef.current !== null) {
              setjobStatus("Done");
              clearInterval(intervalIdRef.current);
            } else if (ts.some((t) => t.status === "Running") && intervalIdRef.current !== null) {
              // console.log("Running");
              setjobStatus("Running");
              intervalIdRef.current = setInterval(fetchTasks, 8000);
              clearInterval(intervalIdRef.current);
            } else {
              clearInterval(intervalIdRef.current);
              intervalIdRef.current = setInterval(fetchTasks, 8000);
            }
          };

          checkTaskStatus(newTaskStatus);
        });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchJob();
    fetchTasks();
    return null;
  }, []);

  useLayoutEffect(() => {
    if (parentRef.current) {
      const parentHeight = parentRef.current.offsetHeight;
      const titleHeight = parentRef.current ? parentRef.current.children[0].offsetHeight : 50;
      setMaxHeight(parentHeight - titleHeight - 48);
    }
  }, [parentRef]);

  // 组件卸载后清除定时器
  useEffect(() => () => clearInterval(intervalIdRef.current), []);

  const handleStartJob = () => {
    try {
      axios.post(HTTP_API.LUCC, {
        operation: "start_task",
        payload: {
          job: jobID,
          task: assignedTask.id,
        },
      });
      setjobStatus("Running");
      handleBackdropClose();
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteJob = () => {
    try {
      axios.post(HTTP_API.LUCC, {
        operation: "delete_jobs",
        payload: { job_id: jobID, task: assignedTask.id },
      });
      handleBackdropClose();
      navigate(`/computing`);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <MainLayout breadcrumbsRoutes={BreadcrumbsRoutes}>
      {assignedTask ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={submitBackdrop}
        >
          <Grid2 container item sx={{ display: "flex", justifyContent: "center" }}>
            <Grid2 justifyContent="center">
              <MKTypography color="white" variant="h4" mb={1}>
                No data were found for {assignedTask.emptytiles} tiles in terms of your request.
              </MKTypography>
            </Grid2>
            <Grid2 container xs={6}>
              <Grid2 xs={6} justifyContent="center" sx={{ display: "flex" }}>
                <MKButton size="large" onClick={handleDeleteJob} sx={{ mx: 2 }}>
                  Cancel Job
                </MKButton>
              </Grid2>
              <Grid2 xs={6} justifyContent="center" sx={{ display: "flex" }}>
                <MKButton size="large" onClick={handleStartJob} sx={{ mx: 2 }}>
                  Continue
                </MKButton>
              </Grid2>
            </Grid2>
          </Grid2>
        </Backdrop>
      ) : null}
      <MKBox component="section">
        <MKBox width="100%" pt={0.1} bgColor="white">
          <Grid2 container justifyContent="space-evenly" sx={{ height: 1, width: 1 }}>
            <Grid2 container xs={3.3}>
              <Grid2 xs={12} sx={{ height: { lg: "0.5" } }} p={0.5}>
                <GridCard title="Information" ref={parentRef}>
                  <MKBox maxHeight={maxHeight} sx={{ height: 1, m: { lg: 0.5, xxl: 1, xxxl: 2 } }}>
                    <Grid2
                      container
                      xs={12}
                      sx={{
                        m: { lg: 0.5, xxl: 1, xxxl: 2 },
                        justifyContent: "center",
                      }}
                    >
                      <Grid2
                        container
                        xs={12}
                        sx={{
                          my: { xxl: 1, xxxl: 2 },
                        }}
                      >
                        <Grid2 xs={4.5} pr={1}>
                          <MKTypography
                            variant="body1"
                            noWrap
                            fontWeight="bold"
                            pb={0.5}
                            sx={{ textAlign: "right" }}
                          >
                            Job Name :
                          </MKTypography>
                        </Grid2>
                        <Grid2 xs={7.5}>
                          <MKTypography variant="body1" noWrap pb={0.5}>
                            {jobInfo ? jobInfo.job_name : " "}
                          </MKTypography>
                        </Grid2>
                      </Grid2>
                      <Grid2
                        container
                        xs={12}
                        sx={{
                          my: { xxl: 1, xxxl: 2 },
                        }}
                      >
                        <Grid2 xs={4.5} pr={1}>
                          <MKTypography
                            variant="body1"
                            noWrap
                            fontWeight="bold"
                            pb={0.5}
                            sx={{ textAlign: "right" }}
                          >
                            Description :
                          </MKTypography>
                        </Grid2>
                        <Grid2 xs={7.5}>
                          <MKTypography variant="body1" noWrap pb={0.5}>
                            {jobInfo ? jobInfo.job_desc : " "}
                          </MKTypography>
                        </Grid2>
                      </Grid2>
                      <Grid2
                        container
                        xs={12}
                        sx={{
                          my: { xxl: 1, xxxl: 2 },
                        }}
                      >
                        <Grid2 xs={4.5} pr={1}>
                          <MKTypography
                            variant="body1"
                            noWrap
                            fontWeight="bold"
                            pb={0.5}
                            sx={{ textAlign: "right" }}
                          >
                            Date Range :
                          </MKTypography>
                        </Grid2>
                        <Grid2 xs={7.5}>
                          <MKTypography variant="body1" noWrap pb={0.5}>
                            {jobInfo ? jobInfo.sensing_date.replace("/", " to ") : " "}
                          </MKTypography>
                        </Grid2>
                      </Grid2>
                      <Grid2
                        container
                        xs={12}
                        sx={{
                          my: { xxl: 1, xxxl: 2 },
                        }}
                      >
                        <Grid2 xs={4.5} pr={1}>
                          <MKTypography
                            variant="body1"
                            fontWeight="bold"
                            noWrap
                            pb={0.5}
                            sx={{ textAlign: "right" }}
                          >
                            Submission Time :
                          </MKTypography>
                        </Grid2>
                        <Grid2 xs={7.5}>
                          <MKTypography variant="body1" noWrap pb={0.5}>
                            {jobInfo ? formatDatetime(jobInfo.submission_time) : " "}
                          </MKTypography>
                        </Grid2>
                      </Grid2>
                      {jobInfo ? (
                        <Grid2
                          container
                          xs={12}
                          sx={{
                            my: { xxl: 1, xxxl: 2 },
                          }}
                        >
                          <Grid2 xs={4.5}>
                            <MKTypography
                              variant="body1"
                              noWrap
                              fontWeight="bold"
                              pb={0.5}
                              sx={{ textAlign: "right", pr: 1 }}
                            >
                              {jobInfo.completion_time === ""
                                ? "Elapsed Time :"
                                : "Completion Time :"}
                            </MKTypography>
                          </Grid2>
                          <Grid2 xs={7.5}>
                            <MKTypography
                              variant="body1"
                              noWrap
                              sx={{ textAlign: "left" }}
                              pb={0.5}
                            >
                              {jobInfo.completion_time === ""
                                ? eplasedTime
                                : formatDatetime(jobInfo.completion_time)}
                            </MKTypography>
                          </Grid2>
                        </Grid2>
                      ) : null}
                    </Grid2>

                    <Divider variant="inset" sx={{ mx: 4 }} />
                    <Grid2
                      container
                      xs={12}
                      p={1}
                      sx={{
                        m: { lg: 0.5, xxl: 1, xxxl: 2 },
                      }}
                    >
                      <Grid2 xs={1} />
                      <Grid2 xs={2.5} sx={{ justifyContent: "center" }}>
                        <CircularProgressWithLabel progress={progress} />
                      </Grid2>
                      <Grid2 xs={2}>
                        <MKBox sx={{ justifyContent: "center" }}>
                          <MKTypography
                            variant="body1"
                            fontWeight="bold"
                            noWrap
                            sx={{ textAlign: "center" }}
                          >
                            Status
                          </MKTypography>
                          <MKTypography variant="body1" noWrap sx={{ textAlign: "center" }}>
                            {jobStatus}
                          </MKTypography>
                        </MKBox>
                      </Grid2>
                      <Grid2 xs={3} pr={1}>
                        {tiles.length !== 0 && grids.list !== 0 ? (
                          <>
                            <MKTypography
                              variant="body1"
                              fontWeight="bold"
                              noWrap
                              sx={{ textAlign: "right" }}
                            >
                              Tiles :
                            </MKTypography>
                            <MKTypography
                              variant="body1"
                              fontWeight="bold"
                              noWrap
                              sx={{ textAlign: "right" }}
                            >
                              Scenes :
                            </MKTypography>
                          </>
                        ) : null}
                      </Grid2>
                      <Grid2 xs={2}>
                        {tiles.length !== 0 && grids.list !== 0 ? (
                          <>
                            <MKTypography
                              variant="body1"
                              noWrap
                              title={`${tiles
                                .filter((t) => t.status === "Done")
                                .length.toString()}/${tiles.length}`}
                            >
                              {tiles.filter((t) => t.status === "Done").length.toString()}/
                              {tiles.length}
                            </MKTypography>
                            <MKTypography
                              variant="body1"
                              noWrap
                              title={`${scenes.doneScenes}/${scenes.allScenes}`}
                            >
                              {scenes.doneScenes}/{scenes.allScenes}
                            </MKTypography>
                          </>
                        ) : null}
                      </Grid2>
                      <Grid2 xs={1}>
                        <MKBox sx={{ justifyContent: "center" }}>
                          <IconButton
                            aria-label="refresh"
                            color="primary"
                            onClick={() => {
                              fetchJob();
                            }}
                          >
                            <RefreshIcon fontSize="medium" />
                          </IconButton>
                        </MKBox>
                      </Grid2>
                    </Grid2>
                  </MKBox>
                </GridCard>
              </Grid2>
              <Grid2 xs={12} sx={{ height: { lg: "0.4" } }} px={0.5}>
                <GridCardLayersComputing map={map} taskStatus={tasks} />
              </Grid2>
              <Grid2
                container
                item
                xs={12}
                sx={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  height: { lg: "0.1" },
                  maxHeight: "30px",
                }}
                px={0.5}
              >
                <Grid2
                  item
                  xs={6}
                  sx={{ justifyContent: "center", display: "flex", alignItems: "center" }}
                >
                  {jobInfo && models.find((model) => model.type === jobInfo.job_desc) ? (
                    <MKButton
                      variant="contained"
                      color="primary"
                      size="medium"
                      href={`/computing/new/${
                        models.find((model) => model.type === jobInfo.job_desc).id
                      }`}
                    >
                      Submit New Job
                    </MKButton>
                  ) : (
                    <MKButton variant="contained" size="medium" color="primary" href="/computing">
                      Submit New Job
                    </MKButton>
                  )}
                </Grid2>
                {/* <Grid2 item xs={6} sx={{ justifyContent: "center", display: "flex" }}> */}
                {/*   {jobInfo ? ( */}
                {/*     <MKButton */}
                {/*       variant="contained" */}
                {/*       color="primary" */}
                {/*       size="medium" */}
                {/*       // disabled */}
                {/*       onClick={() => { */}
                {/*         alert("todo"); */}
                {/*       }} */}
                {/*     > */}
                {/*       Download Zip */}
                {/*     </MKButton> */}
                {/*   ) : ( */}
                {/*     <MKButton variant="contained" size="medium" color="primary" disabled> */}
                {/*       Download Zip */}
                {/*     </MKButton> */}
                {/*   )} */}
                {/* </Grid2> */}
              </Grid2>
            </Grid2>
            <Grid2 xs={8.7} p={0.5}>
              <GridCardMapComputingView
                map={map}
                mapRef={mapRef}
                setMap={setMap}
                className="ol-map-full"
                source={{ gridSource, tileSource, xyzSource, specialSource }}
              />
            </Grid2>
          </Grid2>
        </MKBox>
      </MKBox>
    </MainLayout>
  );
};
export default ComputingJobView;
